import React from 'react';

function DonateSection() {
  return (
    <section id="donar" className="donate">
      <div className="container">
        <h2 className="section-title animate-on-scroll">Ayudanos a llegar más lejos</h2>
        <p className="donate-subtitle animate-on-scroll">
          Ahora podes ser parte de esta gran mitzva! Elegí la mejor forma de colaborar con nosotros
          y ayudanos a reavivar la llama de nuestro legado eterno.
        </p>

        <div className="donation-cards animate-on-scroll">
          <div className="donation-card">
            <div className="donation-icon-box">
              <h3 className="donation-kms">100</h3>
              <p className="donation-kms-label">KMS</p>
            </div>
            <h4 className="donation-title">100 Kilómetros</h4>
            <p className="donation-description">
              Donando 100 Kms nos ayudas a recorrer más camino y visitar así a más personas.
            </p>
            <p className="donation-price">VALOR $36.000</p>
            <a href="https://mpago.la/2Bt6ggq" target="_blank" rel="noopener noreferrer" className="btn-donation">DONAR</a>
          </div>

          <div className="donation-card">
            <div className="donation-icon-box">
              <h3 className="donation-kms">200</h3>
              <p className="donation-kms-label">KMS</p>
            </div>
            <h4 className="donation-title">200 Kilómetros</h4>
            <p className="donation-description">
              Donando 200 Kms nos ayudas a recorrer más camino y visitar así a más personas.
            </p>
            <p className="donation-price">VALOR $77.000</p>
            <a href="https://mpago.la/2guxqFY" target="_blank" rel="noopener noreferrer" className="btn-donation">DONAR</a>
          </div>

          <div className="donation-card">
            <div className="donation-icon-box">
              <h3 className="donation-kms">300</h3>
              <p className="donation-kms-label">KMS</p>
            </div>
            <h4 className="donation-title">300 Kilómetros</h4>
            <p className="donation-description">
              Donando 300 Kms nos ayudas a recorrer más camino y visitar así a más personas.
            </p>
            <p className="donation-price">VALOR $126.000</p>
            <a href="https://mpago.la/2Vcw1my" target="_blank" rel="noopener noreferrer" className="btn-donation">DONAR</a>
          </div>

          <div className="donation-card">
            <div className="donation-icon-box tank">
              <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" fill="currentColor">
                <path d="M19.77 7.23l.01-.01-3.72-3.72L15 4.56l2.11 2.11c-.94.36-1.61 1.26-1.61 2.33 0 1.38 1.12 2.5 2.5 2.5.36 0 .69-.08 1-.21v7.21c0 .55-.45 1-1 1s-1-.45-1-1V14c0-1.1-.9-2-2-2h-1V5c0-1.1-.9-2-2-2H6c-1.1 0-2 .9-2 2v16h10v-7.5h1.5v5c0 1.38 1.12 2.5 2.5 2.5s2.5-1.12 2.5-2.5V9c0-.69-.28-1.32-.73-1.77zM12 10H6V5h6v5zm6 0c-.55 0-1-.45-1-1s.45-1 1-1 1 .45 1 1-.45 1-1 1z"/>
              </svg>
            </div>
            <h4 className="donation-title">Tanque Lleno</h4>
            <p className="donation-description">
              Donando un tanque lleno nos ayudas a recorrer más camino y visitar así a más personas.
            </p>
            <p className="donation-price">VALOR $260.000</p>
            <a href="https://mpago.la/1S3CNr5" target="_blank" rel="noopener noreferrer" className="btn-donation">DONAR</a>
          </div>
        </div>

        <div className="custom-donation animate-on-scroll">
          <h3 className="custom-donation-title">Si deseás donar otro monto podes hacerlo desde aquí</h3>
          <div className="custom-donation-form">
            <a
              href="https://link.mercadopago.com.ar/mitzvatank"
              target="_blank"
              rel="noopener noreferrer"
              className="btn-donation-custom"
            >
              DONAR MONTO PERSONALIZADO
            </a>
          </div>
        </div>
      </div>
    </section>
  );
}

export default DonateSection;
